import { inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';

import {
  HelpDocumentDto,
  HelpState,
  HelpTypeEnum,
} from '@ups/xplat/base/in-app-help';

/**
 * The help store state every anchor needs, read once for the whole app (Bug 35599).
 * Anchors read these signals instead of each subscribing to the store.
 */
@Injectable({ providedIn: 'root' })
export class HelpAnchorState {
  private readonly store = inject(Store);

  readonly showTooltips: Signal<boolean> = toSignal(
    this.store.pipe(HelpState.selectShowTooltips()),
    { initialValue: false }
  );

  private readonly docs: Signal<Record<string, HelpDocumentDto[]>> = toSignal(
    this.store.select(HelpState.selectDocumentDictionary),
    { initialValue: {} }
  );

  /** Whether a tooltip document is loaded for this help path. Reactive when read in an effect. */
  hasTooltip(path: string): boolean {
    return !!this.docs()?.[path]?.some((d) => d.type === HelpTypeEnum.Tooltip);
  }
}
